import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=107a19f9&scoped=true&"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=107a19f9&scoped=true&lang=css&"
import style1 from "./PrivacyNotice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a19f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
